<template>
    <v-app v-if="!isLoading">
        <EmptyPage v-if="emptyGame" />
        <v-main class="background-main" v-else>
            <Menu v-if="!$route.meta.fullScreen" />
            <div class="main-body" :class="{ 'has-betslip': !this.$route.meta.hiddenBetslip || $store.state.isScreenMobile, 'full-screen': $route.meta.fullScreen }">
                <div class="main-screen">
                    <router-view />
                </div>
                <BetslipCompoent v-if="!this.$route.meta.hiddenBetslip || $store.state.isScreenMobile" />
            </div>
        </v-main>
        <Notications />
        <DialogComponent />
    </v-app>
</template>
<script>
import jwt_decode from 'jwt-decode'
import Menu from '@/components/layouts/menu/index.vue'
import Notications from '@/components/common/notications/index.vue'
import BetslipCompoent from '@/components/layouts/betslip/index.vue'
import DialogComponent from '@/components/common/dialog/index.vue'
import EmptyPage from '@/views/404/Error404.vue'
import routerMixins from '@/mixins/router/router-mixin'

import { getParamQueryTheme, isStrEmpty } from '@/utils/utils'
import { deleteGame, getAccount, getCurrency, getGame, getToken, getexternalIdType, setAccount, setCurrency, setCustomerId, setexternalIdType, setGame, setToken } from './services/axios'
import { acceptParentOrigin } from './services/parent-message'
import { CT_PLAYER_TYPE } from './constants/app'

const PRODUCT_FLAGS = {
    lotto590: 'isShow590',
    loto590: 'isShow590',
    lotto480: 'isShow480',
    loto480: 'isShow480',
    lotto452: 'isShow452',
    loto452: 'isShow452',
    lotto645: 'isShow645',
    loto645: 'isShow645',
    lotto545: 'isShow545',
    loto545: 'isShow545',
    lotto459: 'isShow459',
    loto459: 'isShow459',
}

export default {
    components: { Menu, Notications, BetslipCompoent, DialogComponent, EmptyPage },
    mixins: [routerMixins],
    data() {
        return {
            isChecklogin: false,
            screenWidth: window.innerWidth,
            isLoading: true,
            emptyGame: false,
        }
    },
    watch: {
        screenWidth(value) {
            if (value <= 768) {
                this.$store.state.isScreenMobile = true
            } else {
                this.$store.state.isScreenMobile = false
            }
        },
    },
    created() {
        this.fetchData()
        if (this.screenWidth <= 768) {
            this.$store.state.isScreenMobile = true
            this.$store.state.isScreenPhone = this.screenWidth <= 480 ? true : false
        } else {
            this.$store.state.isScreenMobile = false
        }
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('message', this.getMessage)
    },
    mounted() {
        const token = getParamQueryTheme('token')
        if (!isStrEmpty(token)) {
            setToken(token)
            this.checkLogin(token)
            this.removeTokenFromAddress()
        } else if (!isStrEmpty(getToken())) {
            this.checkLogin(getToken())
        }

        this.keepOrSet('account', getParamQueryTheme('account'), setAccount, getAccount)
        this.keepOrSet('currency', getParamQueryTheme('currency'), setCurrency, getCurrency)
        this.$store.state.CURRENCY = getCurrency() || 'CDF'
        this.keepOrSet('externalIdType', getParamQueryTheme('externalIdType'), setexternalIdType, getexternalIdType)
        this.applyProductVisibility(getParamQueryTheme('game'), getParamQueryTheme('hiddenGame'))

        if (!isStrEmpty(getParamQueryTheme('playerType'))) {
            const { RETAIL, ONLINE } = CT_PLAYER_TYPE
            const playerTypeParam = getParamQueryTheme('playerType')
            this.$store.state.playerType = playerTypeParam === RETAIL ? RETAIL : ONLINE
        }

        this.isLoading = false
    },
    methods: {
        getMessage(event) {
            if (!acceptParentOrigin(event.origin)) return
            if (event.data.command === 'set_data') {
                if (!isStrEmpty(event.data.data.token)) {
                    setToken(event.data.data.token)
                    this.checkLogin(event.data.data.token)
                }

                if (!isStrEmpty(event.data.data.account)) {
                    setAccount(event.data.data.account)
                }

                if (!isStrEmpty(event.data.data.currency)) {
                    setCurrency(event.data.data.currency)
                    this.$store.state.CURRENCY = event.data.data.currency
                }

                if (!isStrEmpty(event.data.data.externalIdType)) {
                    setexternalIdType(event.data.data.externalIdType)
                }

                if (!isStrEmpty(event.data.data.game) || !isStrEmpty(event.data.data.hiddenGame)) {
                    this.applyProductVisibility(event.data.data.game, event.data.data.hiddenGame)
                }
            }
        },
        keepOrSet(name, incoming, setter, getter) {
            if (!isStrEmpty(incoming)) setter(incoming)
            else if (isStrEmpty(getter())) setter('')
            return name
        },
        removeTokenFromAddress() {
            const url = new URL(window.location.href)
            if (!url.searchParams.has('token')) return
            url.searchParams.delete('token')
            const next = `${url.pathname}${url.search}${url.hash}`
            window.history.replaceState({}, '', next)
        },
        applyProductVisibility(game, hiddenGame) {
            const flags = ['isShow590', 'isShow480', 'isShow452', 'isShow645', 'isShow545', 'isShow459']
            if (!isStrEmpty(game)) {
                const selected = PRODUCT_FLAGS[game]
                if (!selected) return
                flags.forEach((flag) => {
                    this.$store.state[flag] = flag === selected
                })
                const steps = { isShow590: 1, isShow645: 2, isShow459: 3, isShow545: 4, isShow480: 5, isShow452: 6 }
                this.$store.dispatch('onSwitchBetslip', { step: steps[selected] })
                this.redirectUrl(game)
            }
            if (!isStrEmpty(hiddenGame)) {
                const hiddenList = hiddenGame.split(',')
                Object.keys(PRODUCT_FLAGS).forEach((key) => {
                    if (hiddenList.includes(key)) this.$store.state[PRODUCT_FLAGS[key]] = false
                })
            }
            this.emptyGame = flags.every((flag) => !this.$store.state[flag])
        },
        fetchData() {
            const cart = !isStrEmpty(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')) : []
            const cartRender = !isStrEmpty(localStorage.getItem('cartRender')) ? JSON.parse(localStorage.getItem('cartRender')) : []
            const quantity = !isStrEmpty(localStorage.getItem('quantity')) ? localStorage.getItem('quantity') : 0
            const totalCart = !isStrEmpty(localStorage.getItem('totalCart')) ? localStorage.getItem('totalCart') : 0
            const transact = !isStrEmpty(localStorage.getItem('transact')) ? JSON.parse(localStorage.getItem('transact')) : []
            const transact645 = !isStrEmpty(localStorage.getItem('transact645')) ? JSON.parse(localStorage.getItem('transact645')) : []
            const transact459 = !isStrEmpty(localStorage.getItem('transact459')) ? JSON.parse(localStorage.getItem('transact459')) : []
            const transact545 = !isStrEmpty(localStorage.getItem('transact545')) ? JSON.parse(localStorage.getItem('transact545')) : []
            const transact480 = !isStrEmpty(localStorage.getItem('transact480')) ? JSON.parse(localStorage.getItem('transact480')) : []
            const transact452 = !isStrEmpty(localStorage.getItem('transact452')) ? JSON.parse(localStorage.getItem('transact452')) : []
            const stepCart = !isStrEmpty(localStorage.getItem('stepCart')) ? JSON.parse(localStorage.getItem('stepCart')) : 1
            this.$store.state.cart = cart
            this.$store.state.cartRender = cartRender
            this.$store.state.transact = transact
            this.$store.state.transact645 = transact645
            this.$store.state.transact459 = transact459
            this.$store.state.transact545 = transact545
            this.$store.state.transact480 = transact480
            this.$store.state.transact452 = transact452
            this.$store.state.quantity = parseInt(quantity)
            this.$store.state.totalCart = parseInt(totalCart)
            this.$store.state.stepCart = parseInt(stepCart)
        },
        handleResize() {
            this.screenWidth = window.innerWidth
        },

        async checkLogin(token) {
            try {
                const decodedToken = jwt_decode(token)
                if (!isStrEmpty(decodedToken.customerID)) {
                    setCustomerId(decodedToken.customerID)
                }
                this.$store.state.isLogin = !isStrEmpty(decodedToken.account) && !isStrEmpty(decodedToken.customerID)
            } catch (error) {
                this.$store.state.isLogin = false
            }
        },

        redirectUrl(newGame) {
            const oldRenderGame = getGame()
            if (oldRenderGame !== newGame) {
                setGame(newGame)
                this.routerPush('/')
            } else {
                setGame(newGame)
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/main.scss';

.main-body.full-screen {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    
    .main-screen {
        width: 100% !important;
        max-width: 100% !important;
    }
}
</style>
